import { ArrowDown } from "lucide-react";
import { PROFILE } from "../../lib/data";

const META_ITEMS = [
  { label: "Issue №01", value: "The Portfolio" },
  { label: "Volume", value: "2018 — 2026" },
  { label: "Filed From", value: "Bengaluru, IN", desktopOnly: true },
  { label: "Subject", value: "Brand · Business · Leadership", desktopOnly: true },
];

const HeroMetaStrip = () => (
  <div className="max-w-[1480px] mx-auto px-5 md:px-10 grid grid-cols-12 gap-6 text-[10.5px] tracking-[0.22em] uppercase font-medium pb-10 md:pb-16">
    {META_ITEMS.map((m) => (
      <div
        key={m.label}
        className={`col-span-6 md:col-span-3 ${m.desktopOnly ? "hidden md:block" : ""}`}
      >
        <div className="opacity-50 mb-1">{m.label}</div>
        <div>{m.value}</div>
      </div>
    ))}
  </div>
);

const HeroSubline = () => (
  <div className="max-w-[1480px] mx-auto px-5 md:px-10 mt-10 md:mt-14 grid grid-cols-12 gap-6 hairline-t border-t pt-8 md:pt-10">
    <div className="col-span-12 md:col-span-5">
      <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-3">
        The Role
      </div>
      <div className="text-lg md:text-2xl font-medium leading-snug tracking-tight">
        {PROFILE.role}
      </div>
    </div>
    <div className="col-span-12 md:col-span-5 md:col-start-7">
      <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-3">
        The Thesis
      </div>
      <p className="text-lg md:text-2xl font-medium leading-snug tracking-tight text-[var(--ink)]">
        {PROFILE.tagline}
      </p>
    </div>
  </div>
);

const HeroScrollCue = () => (
  <div className="max-w-[1480px] mx-auto px-5 md:px-10 mt-10 md:mt-14 flex items-center justify-between text-[11px] tracking-[0.22em] uppercase font-medium">
    <div className="flex items-center gap-3 opacity-60">
      <ArrowDown className="w-3.5 h-3.5" strokeWidth={1.5} />
      Scroll the dossier
    </div>
    <div className="opacity-60 hidden md:block">
      {PROFILE.location} · {PROFILE.phone}
    </div>
  </div>
);

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 md:pt-36 pb-10 md:pb-16 hairline-b border-b"
    >
      <HeroMetaStrip />
      <div className="max-w-[1480px] mx-auto px-5 md:px-10">
        <h1 data-testid="hero-masthead" className="masthead">
          Yash<br />Kankaria
          <span className="accent-dot">.</span>
        </h1>
      </div>
      <HeroSubline />
      <HeroScrollCue />
    </section>
  );
};
